import { ResourceType } from "../constant";
import { AgentEffectArgs } from "./AgentEffectArgs";
import { AgentEffectResult } from "./AgentEffectChoices";

export type AgentEffectApply = (props: AgentEffectArgs) => AgentEffectResult;

export class AgentEffectFunction {
  constructor(public readonly apply: AgentEffectApply) {}

  static addResource(amount: number, type: ResourceType): AgentEffectFunction {
    return new AgentEffectFunction(({ player }: AgentEffectArgs) => {
      player.resources.add({
        [type]: amount,
      });
      return true;
    });
  }
}
